import { Box, Text, useColorMode } from '@chakra-ui/react';
import React from 'react';
import { basicUsage } from '../code-blocks';
import CodeBlock from '../CodeBlock';
import { ProgressBar } from 'ms-react-progress-bar';
import { bgColor, borderColor } from '../const';

export const BasicUsage = () => {
	const { colorMode } = useColorMode();
	return (
		<Box my="20px">
			<Text fontSize="2xl" fontWeight="bold" py="10px">
				Basic Usage
			</Text>
			<Box>
				<CodeBlock text={basicUsage} language="jsx" />
				<Box bg={bgColor[colorMode]} border="1px" borderColor={borderColor[colorMode]} borderRadius="sm">
					<Text fontSize="large" mx="10px" fontWeight="bold">
						Output
					</Text>
					<ProgressBar value={40} />
				</Box>
			</Box>
		</Box>
	);
};
